import type { StateTree } from '@makemydeal/dr-dash-types';
import type { Dealership } from '../reducers/dealershipsReducer';

export const getDealerships = (state: StateTree): Dealership[] => {
    return state?.dealerships?.dealerships || [];
};
